/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { createEntity, getEntity, reset, updateEntity } from './admission-consultant.reducer';

export const AdmissionConsultantUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const admissions = useAppSelector(state => state.admission.entities);
  const especialties = useAppSelector(state => state.especialty.entities);
  const admissionConsultantEntity = useAppSelector(state => state.admissionConsultant.entity);
  const loading = useAppSelector(state => state.admissionConsultant.loading);
  const updating = useAppSelector(state => state.admissionConsultant.updating);
  const updateSuccess = useAppSelector(state => state.admissionConsultant.updateSuccess);

  const handleClose = () => {
    navigate(`/admission-consultant${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getAdmissions({}));
    dispatch(getEspecialties({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.assignedOn !== undefined && typeof values.assignedOn !== 'number') {
      values.assignedOn = Number(values.assignedOn);
    }
    if (values.ReleasedOn !== undefined && typeof values.ReleasedOn !== 'number') {
      values.ReleasedOn = Number(values.ReleasedOn);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...admissionConsultantEntity,
      ...values,
      consultant: doctors.find(it => it.id.toString() === values.consultant?.toString()),
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      specialty: especialties.find(it => it.id.toString() === values.specialty?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...admissionConsultantEntity,
          consultant: admissionConsultantEntity?.consultant?.id,
          admission: admissionConsultantEntity?.admission?.id,
          specialty: admissionConsultantEntity?.specialty?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.admissionConsultant.home.createOrEditLabel" data-cy="AdmissionConsultantCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.admissionConsultant.home.createOrEditLabel">
              Create or edit a AdmissionConsultant
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="admission-consultant-id"
                  label={translate('tinyMedicRestApp.admissionConsultant.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.primary')}
                id="admission-consultant-primary"
                name="primary"
                data-cy="primary"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.billable')}
                id="admission-consultant-billable"
                name="billable"
                data-cy="billable"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.assignedOn')}
                id="admission-consultant-assignedOn"
                name="assignedOn"
                data-cy="assignedOn"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.ReleasedOn')}
                id="admission-consultant-ReleasedOn"
                name="ReleasedOn"
                data-cy="ReleasedOn"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.active')}
                id="admission-consultant-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.cursor')}
                id="admission-consultant-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.lastUpdated')}
                id="admission-consultant-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.microSec')}
                id="admission-consultant-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionConsultant.timestampEntry')}
                id="admission-consultant-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="admission-consultant-consultant"
                name="consultant"
                data-cy="consultant"
                label={translate('tinyMedicRestApp.admissionConsultant.consultant')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="admission-consultant-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.admissionConsultant.admission')}
                type="select"
                required
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="admission-consultant-specialty"
                name="specialty"
                data-cy="specialty"
                label={translate('tinyMedicRestApp.admissionConsultant.specialty')}
                type="select"
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/admission-consultant" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AdmissionConsultantUpdate;
